
export class BookableResource{
    constructor(public readonly id:string,public readonly name:string, public readonly prittyUrl:string, public readonly phoneNumber:string, public readonly tenantId:string ){

    }
    public static deSerialize(x:any): BookableResource{
        return new BookableResource(x.id.toLocaleLowerCase(),x.name,x.prittyUrl,x.phoneNumber, x.tenantId);
    }
}